'use strict';

import type { CalendarEvent } from '../Entities/CalendarEvent';
import { EntityCollection } from './EntityCollection';

export class CalendarEventCollection extends EntityCollection<CalendarEvent> {}
